import { render, staticRenderFns } from "./AwarenessDay.vue?vue&type=template&id=79ac6f1a"
import script from "./AwarenessDay.vue?vue&type=script&lang=js"
export * from "./AwarenessDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports